// 文章頁 置底廣告
'use client';

import { useState, useEffect } from 'react';
import { useParams } from 'next/navigation';

import bannerClient from '@/common/apiClient/bannerClient';
import { PROMO_BANNER_POSITION_CODE } from '@/common/constant';
import Image from 'next/image';

const NewsBottomAd = () => {
    const params = useParams();
    const { locale } = params;

    // 置底廣告
    const [pcBanner, setPcBanner] = useState({});
    const [mbBanner, setMbBanner] = useState({});

    // 取得廣告
    const getBanner = async () => {
        try {
            const { banners } = await bannerClient.getBanner(
                locale,
                PROMO_BANNER_POSITION_CODE.BOTTOM_BANNER_PC
            );

            const data = await bannerClient.getBanner(
                locale,
                PROMO_BANNER_POSITION_CODE.BOTTOM_BANNER_MB
            );

            if (banners && banners?.length) setPcBanner(banners?.[0]);
            if (data?.banners?.length) setMbBanner(data?.banners?.[0]);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getBanner();
    }, []);

    return (
        <>
            {/* 桌機版 */}
            {pcBanner?.img &&
                (pcBanner?.link ? (
                    <a
                        href={pcBanner?.link}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="w-full max-w-[680px] overflow-hidden ulg:hidden"
                    >
                        <Image
                            className="gtm-banner-H04 w-full rounded-[8px]"
                            width={680}
                            height={92}
                            src={pcBanner?.img}
                            sizes="550px"
                            alt={pcBanner?.alt || 'advertisement'}
                        />
                    </a>
                ) : (
                    <div className="w-full max-w-[680px] overflow-hidden ulg:hidden">
                        <Image
                            className="gtm-banner-H04 w-full rounded-[8px]"
                            width={680}
                            height={92}
                            src={pcBanner?.img}
                            alt={pcBanner?.alt || 'advertisement'}
                        />
                    </div>
                ))}

            {/* 手機版 */}
            {mbBanner?.img &&
                (mbBanner?.link ? (
                    <a
                        href={mbBanner?.link}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="w-full overflow-hidden hidden ulg:block"
                    >
                        <Image
                            className="gtm-banner-H05 w-full rounded-[8px]"
                            width={680}
                            height={92}
                            sizes="80vw"
                            src={mbBanner?.img}
                            alt={mbBanner?.alt || 'advertisement'}
                        />
                    </a>
                ) : (
                    <div className="w-full overflow-hidden hidden ulg:block">
                        <Image
                            className="gtm-banner-H05 w-full rounded-[8px]"
                            width={680}
                            height={92}
                            src={mbBanner?.img}
                            alt={mbBanner?.alt || 'advertisement'}
                        />
                    </div>
                ))}
        </>
    );
};

export default NewsBottomAd;
